var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5347",
    "data-name": "Group 5347",
    transform: "translate(-1210 -441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5331",
    "data-name": "Group 5331",
    transform: "translate(1187 411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 70,
    height: 70,
    rx: 12.5,
    transform: "translate(23 30)",
    fill: "#3160d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bell_3_",
    "data-name": "bell (3)",
    transform: "translate(1233 464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M22.186,17.618a6.977,6.977,0,0,1-2.478-5.339v-2.9a7.3,7.3,0,0,0-6.25-7.208V1.042a1.042,1.042,0,0,0-2.083,0V2.167a7.3,7.3,0,0,0-6.25,7.208v2.9a6.985,6.985,0,0,1-2.488,5.347,1.823,1.823,0,0,0,1.185,3.207H21.01a1.823,1.823,0,0,0,1.176-3.216Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M12.153,24.125A3.912,3.912,0,0,0,15.98,21H8.326A3.912,3.912,0,0,0,12.153,24.125Z",
    transform: "translate(0.264 0.875)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.f8c4adead0a7d6aaa7515e17ef9978fb.svg";
export { ForwardRef as ReactComponent };